import { LandingPageSettingEnum, UserSettingTypesEnum } from '../../utilities/Constants';

import { IMultiSelectOption } from '../../interfaces/ILookup';
import { SelectDropdownUserSetting } from './SelectDropdownUserSetting';

export function LandingPageSetting() {
    const options = [
        {
            id: Number(LandingPageSettingEnum.QuadDashboard),
            value: LandingPageSettingEnum.QuadDashboard.toString(),
            label: 'Quad Dashboard',
        },
        {
            id: Number(LandingPageSettingEnum.PreferredZone),
            value: LandingPageSettingEnum.PreferredZone.toString(),
            label: 'Preferred Zone',
        },
    ] as IMultiSelectOption[];

    return (
        <SelectDropdownUserSetting
            label={'Preferred Landing Page'}
            options={options}
            settingType={UserSettingTypesEnum.PreferredLandingPage}
        />
    );
}
